/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { RecipientReferralViewRecipient } from './RecipientReferralViewRecipient';
import {
    RecipientReferralViewRecipientFromJSON,
    RecipientReferralViewRecipientFromJSONTyped,
    RecipientReferralViewRecipientToJSON,
    RecipientReferralViewRecipientToJSONTyped,
} from './RecipientReferralViewRecipient';
import type { ReferralType } from './ReferralType';
import {
    ReferralTypeFromJSON,
    ReferralTypeFromJSONTyped,
    ReferralTypeToJSON,
    ReferralTypeToJSONTyped,
} from './ReferralType';

/**
 * 
 * @export
 * @interface RecipientReferralView
 */
export interface RecipientReferralView {
    /**
     * 
     */
    referral_id: string;
    /**
     * 
     */
    sender_facility_id: string;
    /**
     * 
     */
    sender_facility_name?: string | null;
    /**
     * 
     */
    first_name?: string | null;
    /**
     * 
     */
    last_name?: string | null;
    /**
     * 
     */
    dob?: Date | null;
    /**
     * 
     */
    referral_type?: ReferralType | null;
    /**
     * 
     */
    target_discharge_date?: Date | null;
    /**
     * 
     */
    recipient: RecipientReferralViewRecipient;
}



/**
 * Check if a given object implements the RecipientReferralView interface.
 */
export function instanceOfRecipientReferralView(value: object): value is RecipientReferralView {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    if (!('recipient' in value) || value['recipient'] === undefined) return false;
    return true;
}

export function RecipientReferralViewFromJSON(json: any): RecipientReferralView {
    return RecipientReferralViewFromJSONTyped(json, false);
}

export function RecipientReferralViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientReferralView {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'sender_facility_id': json['sender_facility_id'],
        'sender_facility_name': json['sender_facility_name'] === undefined ? undefined : json['sender_facility_name'] === null ? null : json['sender_facility_name'],
        'first_name': json['first_name'] === undefined ? undefined : json['first_name'] === null ? null : json['first_name'],
        'last_name': json['last_name'] === undefined ? undefined : json['last_name'] === null ? null : json['last_name'],
        'dob': json['dob'] === undefined ? undefined : json['dob'] === null ? null : (parseDate(json['dob'])),
        'referral_type': json['referral_type'] === undefined ? undefined : json['referral_type'] === null ? null : ReferralTypeFromJSON(json['referral_type']),
        'target_discharge_date': json['target_discharge_date'] === undefined ? undefined : json['target_discharge_date'] === null ? null : (parseDate(json['target_discharge_date'])),
        'recipient': RecipientReferralViewRecipientFromJSON(json['recipient']),
    };
}

export function RecipientReferralViewToJSON(json: any): RecipientReferralView {
    return RecipientReferralViewToJSONTyped(json, false);
}

export function RecipientReferralViewToJSONTyped(value?: RecipientReferralView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'sender_facility_id': value['sender_facility_id'],
        'sender_facility_name': value['sender_facility_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'dob': value['dob'] == null ? value['dob'] : serializeDate(value['dob']),
        'referral_type': ReferralTypeToJSON(value['referral_type']),
        'target_discharge_date': value['target_discharge_date'] == null ? value['target_discharge_date'] : serializeDate(value['target_discharge_date']),
        'recipient': RecipientReferralViewRecipientToJSON(value['recipient']),
    };
}

